import { supabase } from "@/integrations/supabase/client";

export interface Game {
  id: string;
  name: string;
  cover_url: string | null;
  icon?: string | null;
  description?: string | null;
  is_active?: boolean;
  created_at: string;
  updated_at?: string;
}

// ===============================
// BUSCAR TODOS OS JOGOS
// ===============================

export const fetchGames = async (): Promise<Game[]> => {
  try {
    console.log('🎮 [fetchGames] Buscando todos os jogos...');
    
    // Buscar apenas jogos explicitamente marcados como ativos
    const { data: activeGames, error } = await supabase
      .from('games')
      .select('*')
      .eq('is_active', true)  // Filtro restritivo: apenas jogos com is_active = true
      .order('name');

    if (error) {
      console.error('❌ [fetchGames] Erro ao buscar jogos:', error);
      throw new Error('Falha ao carregar jogos');
    }

    console.log('📊 [fetchGames] Jogos ativos encontrados:', activeGames?.length || 0);
    
    if (activeGames && activeGames.length > 0) {
      console.log('📋 [fetchGames] Lista de jogos ativos:');
      activeGames.forEach((game, index) => {
        console.log(`📋 [fetchGames] ${index + 1}. ${game.name} (ID: ${game.id}, is_active: ${game.is_active})`);
      });
    } else {
      console.warn('⚠️ [fetchGames] Nenhum jogo ativo encontrado! Verifique se há jogos cadastrados no admin panel.');
    }

    return activeGames || [];
  } catch (error) {
    console.error('❌ [fetchGames] Erro geral:', error);
    throw error;
  }
};

// ===============================
// BUSCAR JOGO POR ID
// ===============================

export const fetchGameById = async (id: string): Promise<Game | null> => {
  try {
    const { data, error } = await supabase
      .from('games')
      .select('*')
      .eq('id', id)
      .eq('is_active', true)
      .single();

    if (error) {
      if (error.code === 'PGRST116') {
        return null; // Jogo não encontrado
      }
      console.error('Erro ao buscar jogo:', error);
      throw new Error('Falha ao carregar jogo');
    }

    return data;
  } catch (error) {
    console.error('Erro ao buscar jogo por ID:', error);
    throw error;
  }
};

// ===============================
// BUSCAR JOGOS POR NOME (BUSCA)
// ===============================

export const searchGames = async (query: string): Promise<Game[]> => {
  try {
    const { data, error } = await supabase
      .from('games')
      .select('*')
      .eq('is_active', true)
      .ilike('name', `%${query}%`)
      .order('name')
      .limit(10);

    if (error) {
      console.error('Erro ao buscar jogos:', error);
      throw new Error('Falha ao buscar jogos');
    }

    return data || [];
  } catch (error) {
    console.error('Erro ao buscar jogos:', error);
    throw error;
  }
}; 